import type { RefObject } from 'react'
import { useInView } from './useInView'

export function useOnScreen<T extends HTMLElement>(
    ref: RefObject<T | null>,
    rootMargin = '0px',
) {
    return useInView(ref, { rootMargin, threshold: 0.05 })
}
